module.exports = __webpack_public_path__ + "static/media/auditorium_bannerM.d3312eaa.png";